import { render, staticRenderFns } from "./signupChoice.vue?vue&type=template&id=16ea108a&scoped=true&"
import script from "./signupChoice.vue?vue&type=script&lang=js&"
export * from "./signupChoice.vue?vue&type=script&lang=js&"
import style0 from "./signupChoice.vue?vue&type=style&index=0&id=16ea108a&prod&lang=scss&scoped=true&"
import style1 from "./signupChoice.vue?vue&type=style&index=1&id=16ea108a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea108a",
  null
  
)

export default component.exports